const STORAGE_KEY = "puntavela_tracking";
const URL_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "fbclid", "gclid"];

const readStored = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : "";
};

// Guarda los parámetros de campaña la primera vez que aparecen en la URL.
// Debe correr antes del primer render: Home1 hace navigate() al montarse y borra el query string.
export const captureTrackingParams = () => {
  if (Object.keys(readStored()).length) return;

  const params = new URLSearchParams(window.location.search);
  const found = {};
  URL_PARAMS.forEach((key) => {
    const value = params.get(key);
    if (value) found[key] = value;
  });
  if (!Object.keys(found).length) return;

  found.captured_at = Date.now();
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
  } catch {
    // sessionStorage no disponible (modo privado, cookies bloqueadas)
  }
};

// Función para obtener UTMs, click IDs, referrer y URL actual (sessionStorage primero, luego la URL)
export const getUTMData = () => {
  const stored = readStored();
  const params = new URLSearchParams(window.location.search);
  const get = (key) => stored[key] || params.get(key) || "";
  const referrer = document.referrer || "direct";
  const fbclid = get("fbclid");

  return {
    utm_source: get("utm_source") || (referrer !== "direct" ? (() => { try { return new URL(referrer).hostname.replace("www.", ""); } catch { return referrer; } })() : "direct"),
    utm_medium: get("utm_medium") || (referrer !== "direct" ? "referral" : "none"),
    utm_campaign: get("utm_campaign"),
    utm_term: get("utm_term"),
    utm_content: get("utm_content"),
    fbclid,
    gclid: get("gclid"),
    fbp: getCookie("_fbp"),
    fbc: getCookie("_fbc") || (fbclid ? `fb.1.${stored.captured_at || Date.now()}.${fbclid}` : ""),
    referrer: referrer,
    current_url: window.location.href,
  };
};
